import React, { Component } from 'react';
import makeForm from '../makeForm';
import Form from '../../Common/Form';
import FormGroup from '../../Common/FormGroup';
import Input from '../../Common/Input';
import { dniCleaveOptions, linkTYC, url } from '../../../../config';
import ContinueButton from '../ContinueButton';
import { connect } from 'react-redux';
import yup from 'yup';
import { change15for11, abtest, detectMobile } from '../../../../utils';
import { choices } from '../../../../choices';
import RadioGroup from '../../Common/RadioGroup';
import GoBackButton from '../../Common/GoBackButton';
import s from '../ChatsForm.scss';

class BorrowerForm extends Component {

    render(){
        const {values, handleChange, handleCleaveChange, onSubmit, errors, is_staff, apptype } = this.props
        const borrowerData = (values.first_name && values.last_name && values.phone && values.dni && values.email) ? false : true;
        if(values.childrens === 0){
            values.childrens = '0'
        }
        return(
            <div>
                <div className={s.formContainer}>
                    <div className={s.goBack}><GoBackButton children={'Volver'} link={url('mi-prestamo', apptype)}/></div>
                    <h3 className="chat-title">Datos personales</h3>
                    <Form onSubmit={onSubmit}>
                        <FormGroup errors={errors.first_name}>
                            <Input label="Nombre" name="first_name" value={values.first_name} onChange={handleChange} />
                        </FormGroup>
                        <FormGroup errors={errors.last_name}>
                            <Input label="Apellido" name="last_name" value={values.last_name} onChange={handleChange} />
                        </FormGroup>
                        <FormGroup errors={errors.dni}>
                            <Input label="DNI" name="dni" value={values.dni} onChange={handleCleaveChange} type="tel" cleaveOptions={dniCleaveOptions} tooltip={true} tooltipDesc={'dni'}/>
                        </FormGroup>
                        {(apptype === 'cp') && <FormGroup errors={errors.postal_code}>
                            <Input label="Código Postal de Residencia" name="postal_code" value={values.postal_code} onChange={handleChange} type="tel" />
                            <p className={s.helpText}>Ej.: 1425 (Dígitos numéricos, sin códigos de provincia ni manzana)</p>
                        </FormGroup>}
                        <FormGroup label="" errors={errors.email}>
                            <Input name="email" value={values.email || ''} onChange={handleChange} label="Email" />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                errors={errors.phone}
                                validator={yup.mixed().test({
                                    name: 'is-arg-phone',
                                    message: 'El télefono no es válido para Argentina. Por favor agregá el código de área. Ej. 11 para Capital',
                                    test: value => parseNumber(change15for11(value), 'AR', { extended: true }).valid
                                })}
                                name="phone"
                                value={values.phone || ''}
                                onChange={handleChange}
                                label="Celular"
                                type="tel"
                            />
                            <p className={s.helpText}>Ej.: 1160001234 o 2216000123 (Cod. de área sin el 0 + Número sin el 15)</p>
                        </FormGroup>

                        {is_staff &&
                            <div>
                                <RadioGroup
                                    errors={errors.civil_status}
                                    label="Estado Civil"
                                    name="civil_status"
                                    selected={values.civil_status}
                                    onChange={handleChange}
                                >
                                    {choices.civil_status.map(({ text, value }) => [text, value])}
                                </RadioGroup>
                                <FormGroup errors={errors.childrens}>
                                    <Input
                                        label="¿Cuántos hijos tiene?"
                                        name="childrens"
                                        value={values.childrens || ''}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                                <FormGroup errors={errors.occupation}>
                                    <Input
                                        label="Ocupación"
                                        name="occupation"
                                        value={values.occupation || ''}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                                <FormGroup errors={errors.contact_time}>
                                    <Input
                                        label="Horario de contacto "
                                        name="contact_time"
                                        value={values.contact_time || ''}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                                <FormGroup errors={errors.score}>
                                    <Input label="Score" name="score" value={values.score || ''} onChange={handleChange} />
                                </FormGroup>
                                <FormGroup errors={errors.commitment}>
                                    <Input label="Compromiso inferido" name="commitment" value={values.commitment || ''} onChange={handleChange} />
                                </FormGroup>
                            </div>
                        }
                        <ContinueButton autoFocus={false} disabled={borrowerData} sticky={true}/>
                        <p style={{ color: '#666', fontSize: '14px', margin: '30px', textAlign: 'center', marginTop: '45px' }}>Al hacer click en continuar confirmo que he leído y aceptado los  <a target={(detectMobile()) ? '' : '_blank'} href={linkTYC} className={s.tyc}>términos y condiciones</a></p>
                    </Form>
                </div>
            </div>
        );
}
}

const mapStateToProps = ({ user }) => ({ is_staff: user.is_staff });

export default connect(mapStateToProps)(makeForm(BorrowerForm));
